import { useNodeInfo } from '../hooks/use_node_info';
import Homepage from './Home/Homepage';

// Node feature toggle (hangoutSchedule) — nodes that disable hangout
// scheduling fall back to the Homepage/browse view if someone lands on
// /calendar directly (e.g. a stale bookmark from before the flag flipped).
const ScheduleGate = ({ children }) => {
    const { featureHangoutSchedule } = useNodeInfo();
    return featureHangoutSchedule ? children : <Homepage />;
};

export default ScheduleGate;
